import { Context } from '#store/overmind';
import { Position } from '#store/namespaces/teaser-details/state';
import { Media } from '#types/generated/graphql-types';

export const showDetails = (
  { state }: Context,
  params: { data: Media; position: Position }
) => {
  const queue = state.teaserDetails.queue;
  const items = [];
  if (queue.length > 1) {
    items.push(queue[0]);
  }

  let iri: string;

  if (!!params?.data?.iri) {
    iri = params.data.iri;
  } else {
    console.error('NO IRI GIVEN FOR TEASER DETAILS');
    state.teaserDetails.queue = [];
    return;
  }

  items.push({
    iri,
    position: params.position,
  });

  state.teaserDetails.queue = items;
};

export const hideDetails = ({ state }: Context) => {
  if (state.teaserDetails.queue.length > 0) {
    state.teaserDetails.queue = [];
  }
};
